import { prettyPrice } from '@aviata/text-fns';

export type PriceHistoryDelta = {
  /** Absolute difference (current − previous). */
  delta: number;
  formatted: string;
  direction: 'up' | 'down';
};

export function getPriceHistoryDelta(
  history: { price: string; created_at: string }[] | undefined,
  currency: string,
  initialPrice: string,
): PriceHistoryDelta | null {
  if (!history?.length) return null;

  const sorted = [...history].sort(
    (a, b) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
  );

  const current = parseFloat(sorted[0]?.price ?? '');
  const initial = parseFloat(initialPrice);

  if (Number.isNaN(current) || Number.isNaN(initial) || current === initial) {
    return null;
  }

  const delta = current - initial;
  const CURRENCY_SYMBOLS: Record<string, string> = { KZT: '₸' };
  const currencyDisplay = CURRENCY_SYMBOLS[currency] ?? currency;
  const absFormatted = `${prettyPrice(
    String(Math.abs(delta)),
  )} ${currencyDisplay}`;

  return {
    delta,
    formatted: absFormatted,
    direction: delta > 0 ? 'up' : 'down',
  };
}
